<template>
    <tariff-calculate
        :products="products"
        :onLoadProfileRequests="fetchProfileRequests"
        :onCalculate="tariffCalculate"
        :tariffs="tariffs"
    />
</template>
<script>
    import invert from 'lodash.invert';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { fetchProfileRequests, tariffCalculate } from '../../../services/api/tariff';
    import TariffCalculate from './TariffCalculate';

    export default {
        name: 'tariff-calculate-container',
        components: {
            TariffCalculate,
        },
        created() {
            if (!this.tariffsIsFetched) {
                this.fetchTariffs();
            }
            if (!this.isFetchedProducts) {
                this.fetchRecommendProducts();
            }
        },
        methods: {
            ...mapActions('tariff', ['fetchTariffs']),
            ...mapActions('tariffCalculate', ['fetchRecommendProducts']),
            ...mapActions(['error']),

            fetchProfileRequests() {
                return fetchProfileRequests()
                    .catch((res) => {
                        this.error(res);
                    });
            },
            tariffCalculate(requests) {
                const requestsArray = Object.keys(requests).map((product) => {
                   return {
                       count: requests[product],
                       productId: +product,
                   }
                });

                return tariffCalculate(requestsArray)
                    .catch((res) => {
                        this.error(res);
                    })
            }
        },
        computed: {
            ...mapGetters('tariffCalculate', {
                products: 'products',
                isFetchedProducts: 'isFetched',
            }),
            ...mapGetters('tariff', {
                tariffsIsFetched: 'isFetched',
                tariffs: 'tariffs',
            }),
        }
    }
</script>



// WEBPACK FOOTER //
// TariffCalculateContainer.vue?e561e2c4